import { useStoreRehydrated } from 'easy-peasy';
import { useEffect, useState } from 'react';
import { serverLogoutUser } from '@/stores/auth/services';
import store from '@/stores/store';

export function useSessionGuard(): boolean {
  const isRehydrated = useStoreRehydrated();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isRehydrated) {
      return;
    }

    (async () => {
      const state = store.getState();
      if (state.isAuthenticated && !state.stayLoggedIn) {
        const token = state.signedInUser?.accessToken ?? '';
        serverLogoutUser({ jwt: token })?.catch(() => {});
        const { lastLoginEmail, isTherapistDemo, isPatientDemo } = state;
        await store.getActions().reset();
        await store.getActions().setIsAuthenticated(false);
        await store.getActions().setStayLoggedIn(false);
        if (!(isTherapistDemo || isPatientDemo)) {
          store.getActions().setLastLoginEmail(lastLoginEmail);
        }
        await store.persist.flush();
      }
      setIsReady(true);
    })();
  }, [isRehydrated]);

  return isReady;
}
